import { z } from "zod";
/**
 * Public style used as the default template when creating a new map.
 * The API returns public styles unordered, so the default must be picked by key.
 */
export const DEFAULT_BASEMAP_KEY = "osm-liberty";
export const KEY_RE_STR = "[a-zA-Z0-9-._]";
export const KEY_RE = /^[a-zA-Z0-9-._]*$/;
export const KEY_SCHEMA = z.string().regex(KEY_RE);
//# sourceMappingURL=key.js.map